// extracted by mini-css-extract-plugin
export default {"callInsightsPanelRoot":"CallInsightsPanel_callInsightsPanelRoot__XOKoT"};